import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { connect } from "react-redux";
import { Api, Color } from "services";
import { useHistory } from "react-router-dom";
import ReactPlayer from "react-player";
import {
  ArrowLeftOutlined,
  EditFilled,
  DeleteFilled,
  ExclamationCircleOutlined,
  CopyFilled,
  DownloadOutlined,
} from "@ant-design/icons";
import {
  currentDocument,
  currentTypes,
  deleteNotes,
  fetchAdminLibraryData,
  removemodel,
  setEditObject,
  setUploadContent,
  updateDocumentInfo,
  IsHSL
} from "../../../actions/digitalLibrary";
import EditInformation from "../modals/editInformation";
import CloneInformation from "../modals/cloneInformation";
import DeleteConfirm from "../modals/deleteConfirm";
import YTPlayer from "components/ytPlayer";
import Axios from 'axios'
import fileDownload from 'js-file-download'
import ReactPlayerHoc from "components/ReactPlayerHoc";

const { confirm } = Modal;

// A locally uploaded Digital Library video is stored on S3 under its raw upload key
// (`<uuid>.<ext>`, see uploadfiles.js) and then transcoded server-side into an HLS
// rendition served from Api.hlsUrl.
//
// Handing the player `Api.dlS3Url + key` plays the ORIGINAL uploaded file. That works
// by accident for formats a browser can decode natively (.mp4) and fails outright for
// everything transcoding exists to normalise - and UploadPdf.js accepts .flv, .avi and
// .mkv, none of which any browser can play raw.
//
// So build the candidates the file could be playable as and let the player walk them
// on error, rather than betting everything on one URL. Formats that already play
// directly keep their current URL first, so nothing that works today changes; the
// transcoded playlist is tried first only for the formats that need it.
const WEB_PLAYABLE_EXTENSIONS = ["mp4", "m4v", "webm", "ogg", "ogv", "mov", "m3u8"];
const buildVideoPlaybackUrls = (rawPath, preferHls) => {
  if (!rawPath) return [];
  if (/^https?:/i.test(rawPath)) return [rawPath];
  const dot = rawPath.lastIndexOf(".");
  const hasExt = dot > rawPath.lastIndexOf("/");
  const base = hasExt ? rawPath.slice(0, dot) : rawPath;
  const ext = hasExt ? rawPath.slice(dot + 1).toLowerCase() : "";
  const transcodedPlaylists = [
    `${Api.hlsUrl}${base}.m3u8`,       // transcoder output keyed by the same name
    `${Api.hlsUrl}${base}/master.m3u8` // ...or as a playlist folder
  ];
  if (!WEB_PLAYABLE_EXTENSIONS.includes(ext)) {
    // Unplayable as uploaded - the transcode is the only thing that can work.
    return [...transcodedPlaylists, `${Api.hlsUrl}${rawPath}`, `${Api.dlS3Url}${rawPath}`];
  }
  return preferHls
    ? [`${Api.hlsUrl}${rawPath}`, ...transcodedPlaylists, `${Api.dlS3Url}${rawPath}`]
    : [`${Api.dlS3Url}${rawPath}`, ...transcodedPlaylists, `${Api.hlsUrl}${rawPath}`];
};

function Viewpdf({
  file, filePath, fileLink,
  currentfiletoshow,
  currentId,
  currentDocument,
  deleteNotes,
  fetchAdminLibraryData,
  currentType,
  currentTypes,
  removemodel,
  user,
  documentInfo,
  updateDocumentInfo,
  setEditObject,
  setUploadContent,
  isHSL
}) {
  const history = useHistory();
  const [isVisibl, setIsModalVisibl] = useState(false);
  const [cloneModal, setCloneModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [modal, setmodal] = useState(false);
  // The candidate URLs this video could be playable as, and which one we're on.
  // onError below advances through them - see buildVideoPlaybackUrls above.
  const [playbackUrls, setPlaybackUrls] = useState([]);
  const [playbackIndex, setPlaybackIndex] = useState(0);
  const linkPath = playbackUrls[playbackIndex] || '';
  removemodel();

  const handleHistory = () => {
    updateDocumentInfo({});
    currentDocument(0);
    setEditObject({});
    setUploadContent({});
    IsHSL(false)
    history.goBack();
  };

  const handleDeletenotes = (id) => {
    // return confirm({
    //     title: `Do you want to delete the content?`,
    //     icon: <ExclamationCircleOutlined />,
    //     content: 'Please click OK to confirm',
    //     onOk() {deleteNotes(id,false)
    //       history.goBack()

    //     },
    //     onCancel() {},
    //   })
    setIsDeleteModal(true);
  };
  useEffect(() => {
    console.log('isHSL', filePath, fileLink);

    // An external link (YouTube, Drive, a direct video URL) is used verbatim - there's
    // no uploaded file behind it to transcode. A stored file gets the candidate list.
    setPlaybackUrls(filePath ? buildVideoPlaybackUrls(filePath, isHSL) : fileLink ? [fileLink] : []);
    setPlaybackIndex(0);
  }, [isHSL, filePath, fileLink])

  const handleDownload = (file, name, type) => {
    console.log("name", name)
    Axios
      .get(`${Api.dlS3Url}${file}`, {
        responseType: "blob",
      })
      .then((res) => {
        if (res.data) {
          fileDownload(res.data, `${name}.${type == "video" ? "video" : "pdf"}`);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };


  // YouTube URL regex
  const youtubeRegExp = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/i;
  // General video URL regex (matches .mp4, .webm, .ogg, etc.)
  const videoRegExp = /\.(mp4|webm|ogg|mov|m4v|avi|wmv|flv|mkv)(\?.*)?$/i;
  // Google Drive video regex
  const driveRegExp = /drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)\//i;

  // Function to extract the video ID from a Google Drive URL
  const getIframeSrc = (url) => {
    const match = url.match(/\/d\/(.+?)\//);
    if (match && match[1]) {
      return `https://drive.google.com/file/d/${match[1]}/preview`;
    }
    return null;
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        style={{
          width: "100%",
          height: "5%",
          marginBottom: "5px",
          background: "",
          justifyContent: "space-between",
          display: "flex",
          paddingLeft: "5px",
          paddingRight: "5px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ArrowLeftOutlined
            style={{ fontSize: "150% ", color: "#636363" }}
            onClick={() => handleHistory()}
          />
        </div>
        {user.access.includes("digital-library-admin") ||
          user.access.includes("digital-library-superadmin") ||
          user.access.includes("digital-library-dataoperator") ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <EditFilled style={{ fontSize: "150% ", color: "#636363" }} />
            <div
              className="cursor-pointer"
              style={{
                marginRight: "20px",
                marginLeft: "5px",
                fontSize: "14px",
                color: "#636363",
                font: "normal normal normal 14px/16px Roboto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => setIsModalVisibl(true)}
            >
              {" "}
              Edit
            </div>
            {isVisibl && (
              <EditInformation
                ismodelvisible={isVisibl}
                setmodevisible={setIsModalVisibl}
                id={currentId}
                setmodal={setmodal}
                types={currentType}
                title={documentInfo.title}
              />
            )}

            <CopyFilled style={{ fontSize: "150% ", color: "#636363" }} />
            <div
              className="cursor-pointer"
              style={{
                marginRight: "20px",
                marginLeft: "5px",
                fontSize: "14px",
                color: "#636363",
                font: "normal normal normal 14px/16px Roboto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => setCloneModal(true)}
            >
              Clone
            </div>
            {cloneModal && (
              <CloneInformation
                ismodelvisible={cloneModal}
                setmodevisible={setCloneModal}
                id={currentId}
                setmodal={setmodal}
                types={currentType}
                title={documentInfo.title}
              />
            )}

            <DeleteFilled style={{ fontSize: "150% ", color: "#636363" }} />
            <div
              className="cursor-pointer"
              style={{
                marginRight: "20px",
                marginLeft: "5px",
                fontSize: "14px",
                color: "#636363",
                font: "normal normal normal 14px/16px Roboto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => handleDeletenotes()}
            >
              Delete
            </div>
            {(documentInfo?.status == 'Published' && documentInfo?.file && (user.access.includes('digital-library-admin') || user.access.includes('digital-library-superadmin'))) &&
              <>
                <DownloadOutlined style={{ fontSize: "150% ", color: "#636363" }} />
                <div
                  className="cursor-pointer"
                  style={{
                    marginRight: "20px",
                    marginLeft: "5px",
                    fontSize: "14px",
                    color: "#636363",
                    font: "normal normal normal 14px/16px Roboto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => handleDownload(documentInfo?.file, documentInfo?.title, documentInfo?.type)}
                >
                  Download
                </div>
              </>}
          </div>
        ) : null}
        {isDeleteModal && (
          <DeleteConfirm
            isModalVisible={isDeleteModal}
            setModalVisible={setIsDeleteModal}
            id={currentId}
            notes={true}
            history={history}
          />
        )}
      </div>
      {console.log("currentfiletoshow", currentfiletoshow, linkPath)}
      {currentfiletoshow == 'link' ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            padding: "50px"
          }}
        >

          {console.log('linkPath', linkPath, linkPath && linkPath.match(youtubeRegExp), linkPath && (linkPath.match(videoRegExp)))}
          {
            linkPath && linkPath.match(youtubeRegExp) ? (
              <YTPlayer keyboardControls={true} videoUrl={linkPath} />
            ) : linkPath && linkPath.match(driveRegExp) && getIframeSrc(linkPath) ? (
              <iframe
                src={getIframeSrc(linkPath)}
                width="640"
                height="480"
                allow="autoplay"
                allowFullScreen
                style={{ marginTop: 30 }}
                title="Google Drive Video"
              ></iframe>
            ) : linkPath && linkPath.match(videoRegExp) ? (
              <ReactPlayer
                style={{ marginTop: 30 }}
                height={"70%"}
                width={"90%"}
                url={linkPath}
                controls={true}
              />
            ) : null
          }


          {/* {
            linkPath && linkPath.match(youtubeRegExp) ?
              <YTPlayer keyboardControls={true} videoUrl={linkPath} />
              : linkPath && (linkPath.match(videoRegExp)) ?
                <ReactPlayer
                  style={{ marginTop: 30 }}
                  height={"70%"}
                  width={"90%"}
                  // config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                  // onContextMenu={e => e.preventDefault()}
                  url={linkPath}
                  controls={true}
                />
                : null
          } */}
          {/* <ReactPlayer
            style={{ marginTop: 30 }}
            height={"70%"}
            width={"90%"}
            config={{ file: { attributes: { controlsList: 'nodownload' } } }}
            onContextMenu={e => e.preventDefault()}
            url={linkPath}
            controls={true}
          /> */}
          {/* <YTPlayer videoUrl={linkPath} keyboardControls={true} /> */}
        </div>
      ) :
        (documentInfo?.type == 'lecture-notes' || currentfiletoshow == 'pdf') ?
          (
            <div style={{ height: "100%", width: "100%" }}>
              <iframe
                width="100%"
                height="100%"
                src={`${Api.dlS3Url}${file}#toolbar=0`}
                frameborder="0"
              ></iframe>
            </div>
          ) :
          (
            <div style={{ height: "100%", width: "100%", }}>
              <ReactPlayerHoc
                // Remount on each candidate so the underlying player re-initialises
                // instead of holding on to the failed source.
                key={linkPath}
                style={{ marginTop: 30 }}
                height={"70%"}
                width={"90%"}
                config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                onContextMenu={e => e.preventDefault()}
                url={linkPath}
                onError={() => {
                  // This URL didn't resolve - try the next rendition. Runs out
                  // harmlessly on the last candidate, leaving the player's own
                  // error state visible.
                  setPlaybackIndex(i => (i + 1 < playbackUrls.length ? i + 1 : i));
                }}
                controls={true}
                // contentId={currentId}
                keyboardControls={true}
              // moduleType={'DIGITALLIBRARY'}
              />
            </div>
          )
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  const { file, currentfiletoshow, currentId, currentType, documentInfo, isHSL, filePath, fileLink } =
    state.digitalLibrary;
  const { user } = state.session;
  return {
    file,
    currentfiletoshow,
    currentId,
    currentType,
    user,
    documentInfo,
    isHSL,
    filePath, fileLink
  };
};

const mapDispatchToProps = (dispatch) => ({
  deleteNotes: (id, fetch) => dispatch(deleteNotes(id, fetch)),
  currentDocument: (id) => dispatch(currentDocument(id)),
  currentTypes: (type) => dispatch(currentTypes(type)),
  fetchAdminLibraryData: () => dispatch(fetchAdminLibraryData()),
  removemodel: () => dispatch(removemodel()),
  updateDocumentInfo: (data) => dispatch(updateDocumentInfo(data)),
  setEditObject: (object) => dispatch(setEditObject(object)),
  setUploadContent: (object) => dispatch(setUploadContent(object)),
  IsHSL: (bool) => dispatch(IsHSL(bool))
});

export default connect(mapStateToProps, mapDispatchToProps)(Viewpdf);
